import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { GroupeUser } from 'features/groups';

import type { UserInfo } from './types';

export interface UsersAdminState {
  selectedUserId: number | null;
  selectedUser: UserInfo | GroupeUser | null;
}

const initialState: UsersAdminState = {
  selectedUserId: null,
  selectedUser: null
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    changeActiveUser: (state, action: PayloadAction<UserInfo | GroupeUser | null>) => {
      state.selectedUser = action.payload;
    },
    changeActiveUserId: (state, action: PayloadAction<number | null>) => {
      state.selectedUserId = action.payload;
    },
  },
});

export const selectActiveUser = (state: RootState) => state.users.selectedUser;
export const selectActiveUserId = (state: RootState) => state.users.selectedUserId;

export const { changeActiveUser, changeActiveUserId } = usersSlice.actions;
export { usersSlice };
